import React, { useState, useEffect, useCallback } from 'react';
import { Header } from '../../components/Layout';

let scrollCache = 0;

/**-------------------------------------------------------------
 1.2.1.3 이용안내 화면_2
 -------------------------------------------------------------
 > http://basic.pointweb.kr/charge/public/html/public/pay.html
 -------------------------------------------------------------*/
function MainInfo() {
  const [inited] = useState(false);

  const cacheScroll = useCallback(() => {
    if (!/\/voice\/?$/.test(window.location.pathname)) return;
    scrollCache = window.scrollY;
  }, []);

  useEffect(() => {
    window.scrollTo(0, scrollCache);
  }, [inited]);

  useEffect(() => {
    window.addEventListener('scroll', cacheScroll);
    return () => window.removeEventListener('scroll', cacheScroll);
  }, [cacheScroll]);

  return (
    <>
      <Header title={'이용안내'} isInfoMenu={true} isActive={'1'} />

      <div id="page-scroll-available" style={{ paddingBottom: '120px' }}>
        <div className="charger-guide">
          <div className="version">Ver. 2.0.0</div>
          <span className="info-header">
            티맵결제 충전소<br />
            이렇게 이용해주세요.
          </span>

          <div className="info-body">
            <div className="info-box">
              <div className="title">1.충전 시작하기</div>
              <span className="ment">
                ‘충전 시작하기' 버튼을 누르고 충전기에 부착되어 있거나 화면에 표시된 TMAP QR 코드를 스캔해 주세요.
              </span>
            </div>
            <div className="info-box">
              <div className="title">2.커넥터 연결</div>
              <span className="ment">차량에 커넥터를 연결하면 충전이 시작됩니다.</span>
            </div>
            <div className="info-box">
              <div className="title">3.충전종료</div>
              <span className="ment">충전이 종료되면, 충전량만큼 자동으로 결제됩니다.</span>
              <li>충전기의 종료 버튼을 눌러도 종료가 되지 않을 때, 차량에서 커넥터를 분리해주세요.</li>
              <li>일부 충전기는 시작 또는 종료 버튼을 눌러야 충전이 시작되거나 종료됩니다.</li>
              <li>
                티맵을 통한 충전 결제 단가는 티맵 앱 내 충전소 상세 정보 화면에서 확인하실 수 있습니다.
                <br/>
                충전기 또는 충전소 현장에 안내된 요금은 각 충전기 운영사에서 관리하는 요금 체계로, 티맵 결제 단가와 상이할 수 있으니 이용시 참고 부탁드립니다.
              </li>


            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export { MainInfo };